import { CustomTextField, InputPropsForAddAffiliates, emailRegexPattern, handleonKeyDownForEmailId } from '../../../helper';
import styles from '../../../features/ChangePassword/ResetPassword.module.css'

interface EmailProps {
    errors: any,
    register: any,
    disabled: boolean,
  moduleName: string,
  className?: string
}
const EmailTextField = CustomTextField();
const EmailInputField = ({errors,register,disabled, moduleName, className}: EmailProps) => {
  return (
    <>
    <EmailTextField 
    variant={"outlined"}
    className={className}
    name={'email'}
    fullWidth
    {...register("email",{
      required: "Email is required!",
      pattern:{
          value: emailRegexPattern,
          message: "Enter valid email"
        }
    })}
    placeholder={"Enter Email"}
    InputProps={{
        style: {
          ...InputPropsForAddAffiliates,
          boxSizing: "border-box",
          width: "100%",
        },
      }}
      onKeyDown={(e) => handleonKeyDownForEmailId(e, moduleName)}
      error={Boolean(errors?.email?.message)}
      disabled={disabled}
    />
    <span className={styles.errorMsgStyle}>{errors?.email?.message}</span>
    </>
  )
}

export default EmailInputField
